export default "__VITE_ASSET__BAH5GCU9__"